<template>
    <ImgComparisonSlider ref="slider" value="50" class="zdf-comparison-slider" @click="clickTracking()">
        <slot>
            <!-- eslint-disable -->
            <img ref="before" src="" slot="first" style="width: 100%" alt="" />
            <img ref="after" src="" slot="second" style="width: 100%" alt="" />
            <!-- eslint-enable -->
        </slot>
    </ImgComparisonSlider>
</template>

<script setup>
import { ImgComparisonSlider } from '@img-comparison-slider/vue';
import { inject } from 'vue';

const tracking = inject('$tracking');
let tracked = false;

function clickTracking()
{
    if (!tracked)
    {
        //const src = new URL(img_before.value.src);
        tracking.actionClick('vollbild_vergleich_action_button', '');
        tracked = true;
    }
}

</script>